import React, { useCallback, useState } from "react";

import { GlobalStyle } from "./GlobalStyle";
import CoursesTable from "./components/CoursesTable";
import Selector from "./components/Selector";
import { useSchoolSettings } from "./hooks/useSchoolSettings";

function App() {
  const { styling, loading } = useSchoolSettings();

  const [activeProgram, setProgram] = useState();
  const [selectives, setSelectives] = useState([]);

  const courses = [];

  if (activeProgram) {
    courses.push(...activeProgram.acf.obligatoriske_fag);

    courses.sort((a, b) => {
      return a.studieretningfag === b.studieretningfag
        ? 0
        : b.studieretningfag
        ? -1
        : 1;
    });
  }
  if (selectives) {
    courses.push(...selectives.map((s) => ({ ...s, isSelective: true })));
  }

  const filteredCourses = courses.filter((c) => !!c?.fag);

  const timer = filteredCourses.reduce(
    (total, { timer_1g, timer_2g, timer_3g }) => [
      total[0] + parseInt(timer_1g || 0, 10),
      total[1] + parseInt(timer_2g || 0, 10),
      total[2] + parseInt(timer_3g || 0, 10),
    ],
    [0, 0, 0]
  );

  const onChange = useCallback((p) => {
    setProgram(p);
    setSelectives([]);
  }, []);

  if (loading) {
    return null;
  }

  return (
    <div
      className={
        activeProgram ? `studySelector_${activeProgram?.acf?.type}` : ""
      }
    >
      <GlobalStyle styling={styling} />
      <Selector
        onChange={onChange}
        activeProgram={activeProgram}
        selectives={selectives}
        setSelectives={setSelectives}
        selectedCourses={filteredCourses}
        timer={timer}
      />
      <CoursesTable selectedCourses={filteredCourses} timer={timer} />
    </div>
  );
}

export default App;
